import React from "react";

const StorySection = () => {
  return (
    <section className="relative bg-lab-ink text-lab-paper border-t border-lab-rule">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
            <div>§ 01</div>
            <div className="text-lab-paper mt-1">Notice</div>
          </div>

          <div className="col-span-12 md:col-span-7 space-y-6">
            <p className="text-xl md:text-2xl leading-snug text-lab-paper">
              Azerty Labs was built around a single thesis: learned
              behavior belongs inside the instrument, not on a server.
              Between 2020 and 2022 that work sat on microcontrollers •
              inside the power, space, and latency budget of a 3U Eurorack
              panel • with inference running where the audio was made.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-lab-paper-dim">
              Three modules were designed in-house: Pronaos, a USB-MIDI
              interface with an on-module semantic layer running generative
              rhythm; Gatekeeper, a low-noise bridge for routing rack
              signals through off-module inference; and Beetlejuice, a
              compact PSU designed end-to-end with AI assistance before
              that was common practice. Two reached production. Alongside
              the originals, open-source platforms • notably Allen
              Synthesis's EuroPi, used as a target for small rhythmic ML
              models • were assembled in small batches, and bespoke builds
              were made for artists on commission.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-lab-paper-dim">
              The lab closed in 2022. COVID-era component prices exploded
              • silicon that had been two euros the year before was quoted
              at ten, when it was available at all • and the post-pandemic
              Eurorack market contracted sharply as discretionary spending
              pulled back. The math stopped working without cutting
              corners on the signal path. This site is the archive of what
              was built.
            </p>
          </div>

          <div className="col-span-12 md:col-span-3 md:col-start-10 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim space-y-4">
            <div className="border-t border-lab-rule pt-4 flex justify-between">
              <span>Founded</span>
              <span className="text-lab-paper tabular-nums">2020</span>
            </div>
            <div className="border-t border-lab-rule pt-4 flex justify-between">
              <span>Closed</span>
              <span className="text-lab-paper tabular-nums">2022</span>
            </div>
            <div className="border-t border-lab-rule pt-4 flex justify-between">
              <span>Location</span>
              <span className="text-lab-paper">Brest, FR</span>
            </div>
            <div className="border-t border-lab-rule pt-4 flex justify-between">
              <span>Founder</span>
              <span className="text-lab-paper">Chloé Lavrat</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
